import { Routes } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { HomeComponent } from './home/home.component';
import { MidiCreatorComponent } from './midi-creator/midi-creator.component';
var appRoutes = [
    { path: 'home', component: HomeComponent },
    { path: 'midi-creator', component: MidiCreatorComponent },
    { path: 'about', component: AboutComponent },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: '**', redirectTo: '/home' },
];
var ɵ0 = {};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
